/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HolidayDto } from '../models/HolidayDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HolidayControllerService {
    /**
     * @param uuid
     * @returns HolidayDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<HolidayDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/holidays/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns HolidayDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: HolidayDto,
    ): CancelablePromise<HolidayDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/holidays/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/holidays/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns HolidayDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<HolidayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/holidays',
        });
    }
    /**
     * @param requestBody
     * @returns HolidayDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: HolidayDto,
    ): CancelablePromise<HolidayDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/holidays',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
